import { __assign } from "tslib";
import * as React from 'react';
export default function Toolbar(props) {
    var rootStyle = __assign(__assign({}, styles.root), props.style);
    return (React.createElement("div", __assign({}, props, { style: rootStyle })));
}
var styles = {
    root: {
        backgroundColor: '#f5f5f5',
        borderBottom: '1px solid #ddd',
    },
};
//# sourceMappingURL=Toolbar.js.map